// import config from 'config';

/* eslint-disable */
import { authHeader } from '../_helpers';
import { api } from '../_helpers/api';
import * as Cookies from 'js-cookie';

export const userService = {
    login,
    logout,
    getAll,
    getDataUser
};

function login(email, password) {
    return api.postData('/auth/login',{
        'email' : email,
        'password' : password
    },true)
        // .then(handleResponse)
        .then(response => {
            // login successful if there's a jwt token in the response
            if (response.access_token) {
                Cookies.set('x-access-token', response.access_token);
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(response.user));
            }

            return response.user;
        });
}

function getDataUser(token) {
    return api.fetchData('/users/data-user-token')
        // .then(handleResponse)
        .then(response => {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('user', JSON.stringify(response.data));
            localStorage.setItem('islogged', true);

            return response.data;
        });
}

export async function registrasi(form) {
    return api.postData('/auth/register',form,true)
        // .then(handleResponse)
        .then(response => {
            if (response.code == 500) {
                return response;
            }else{
                return response;
            }
        });
}

export async function updateUser(form) {
    return api.postData('/users/update-user',form,true)
        // .then(handleResponse)
        .then(response => {
            if (response.code == 500) {
                return false;
            }else{
                return true;
            }
        });
}

export async function listUser() {
    return api.fetchData('/users/list-user')
        // .then(handleResponse)
        .then(response => {
            if (response.code == 500) {
                return response.data;
            }else{
                return response.data;
            }
        });
}

export async function dataUser(id_user) {
    return api.fetchData('/users/data-user', {
        id: id_user
    })
        // .then(handleResponse)
        .then(response => {
            if (response.code == 500) {
                return response.data;
            }else{
                return response.data;
            }
        });
}



function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`http://localhost:8080/users`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}